var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-register"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"register__head"},[_c('h2',[_vm._v(_vm._s(_vm.$t('register.title')))])]),_c('div',{staticClass:"register-main"},[_c('pro-form',{attrs:{"label-width":"160px","label-suffix":":","label-position":"left","model":_vm.model,"fields":_vm.fields,"rules":_vm.rules,"submitter":{
          submitButtonProps: {
            loading: _vm.loading
          },
          submitText: _vm.$t('register.submit-text'),
          resetText: _vm.$t('register.reset-text')
        }},on:{"submit":_vm.submit}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }